import {
  LOGIN_REQUEST,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_USER_SUCCESS,
} from '../constants/actionTypes'

import { push } from 'react-router-redux'
import 'isomorphic-fetch'

import processError from '../helpers/processError'

import { getCurrentUser, unsetCurrentUser } from './currentUser'

import analytics from '../helpers/segmentAnalytics'

function requestLogin() {
  return {
    type: LOGIN_REQUEST,
    isFetching: true,
    isAuthenticated: false,
  }
}

function receiveLogin(user) {
  return {
    type: LOGIN_USER_SUCCESS,
    isFetching: false,
    isAuthenticated: true,
    reggora_auth_token: user.token,
  }
}

function loginError(message, statusCode) {
  return {
    type: LOGIN_USER_FAILURE,
    isFetching: false,
    isAuthenticated: false,
    message,
    statusCode,
  }
}

export function loginUser(creds, justRegistered) {
  const config = {
    method: 'POST',
    accept: 'application/json',
    body: JSON.stringify({ username: creds.username, password: creds.password }),
  }
  return (dispatch) => {
    dispatch(requestLogin())
    return fetch(SERVER_BASE_URL + '/api/auth', config)
      .then((response) => {
        return response.json().then((user) => ({ user, response })
        ).then(({ user, response }) => {
          if (!response.ok) {
            dispatch(loginError(processError(user), response.status))
            return Promise.reject(user)
          } else {
            localStorage.setItem('reggora_auth_token', user.token)
            dispatch(receiveLogin(user))
            return dispatch(getCurrentUser(true, justRegistered))
          }
        }).catch((err) => {
          console.log(err)
        })
      })
  }
}

export function impersonationLogin(token) {
  return (dispatch) => {
    localStorage.setItem('reggora_auth_token', token)
    dispatch(receiveLogin({ token }))
    return dispatch(getCurrentUser(true))
  }
}

function requestLogout() {
  return {
    type: LOGOUT_REQUEST,
    isFetching: true,
    isAuthenticated: true,
  }
}

function receiveLogout() {
  return {
    type: LOGOUT_USER_SUCCESS,
    isFetching: false,
    isAuthenticated: false,
  }
}

export function logoutUser() {
  const authToken = localStorage.getItem('reggora_auth_token')
  const config = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  }
  return (dispatch) => {
    fetch(SERVER_BASE_URL + '/api/auth/logout', config).catch(() => {})
    dispatch(requestLogout())
    localStorage.removeItem('reggora_auth_token')
    analytics.userLogOut()
    dispatch(receiveLogout())
    dispatch(unsetCurrentUser())
    dispatch(push('/login'))
  }
}
